// Free-text fields (names, remarks, material codes, etc.) should only ever
// contain letters, numbers, spaces, and - _ / . — strips anything else as
// it's typed so special characters can never sneak in via keyboard or scan.
const sanitizeText = (value) => {
  if (value === undefined || value === null) {
    return value;
  }
  return value.toString().replace(/[^a-zA-Z0-9\s\-_/.]/g, "");
};

export default sanitizeText;
